// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"174":"1194ffc8","369":"a21425f2","565":"59c1b13a","856":"ab61be89","890":"59c1b13a","945":"3b64708b"}[chunkId] + ".css";
};